import { __decorate, __metadata } from "tslib";
import { IsUndefinable, LengthWithLVS } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsBoolean, IsOptional, IsString } from 'class-validator';
import { VendorExposeGroup } from '../interface';
import { CreateBaseMetadataDto } from './CreateBaseMetadataDto';
export class CreateSquareMetadataDto extends CreateBaseMetadataDto {
    constructor() {
        super(...arguments);
        this.markOrderInProgress = false;
        this.isDeliveryEnabled = true;
    }
}
__decorate([
    ApiProperty({ type: () => String, description: 'Order notes separator', example: '|' }),
    IsString({ always: true }),
    IsOptional({ groups: [VendorExposeGroup.PATCH] }),
    LengthWithLVS(1, 10, { always: true }),
    Expose({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.READ, VendorExposeGroup.PATCH, VendorExposeGroup.FIXTURE] }),
    __metadata("design:type", String)
], CreateSquareMetadataDto.prototype, "notesSeparator", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, description: 'If true, show tips amount on check', example: false }),
    IsBoolean({ always: true }),
    IsOptional({ always: true }),
    Expose({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.READ, VendorExposeGroup.PATCH, VendorExposeGroup.FIXTURE] }),
    __metadata("design:type", Boolean)
], CreateSquareMetadataDto.prototype, "showTip", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, description: 'If true, show ready time on check', example: false }),
    IsBoolean({ always: true }),
    IsOptional({ always: true }),
    Expose({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.READ, VendorExposeGroup.PATCH, VendorExposeGroup.FIXTURE] }),
    __metadata("design:type", Boolean)
], CreateSquareMetadataDto.prototype, "showReadyTime", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, description: 'If true, send prep_time_duration to POS', default: true }),
    IsBoolean({ always: true }),
    IsOptional({ always: true }),
    Expose({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.READ, VendorExposeGroup.PATCH, VendorExposeGroup.FIXTURE] }),
    __metadata("design:type", Boolean)
], CreateSquareMetadataDto.prototype, "sendPreparationTime", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Square check title template', example: '{{ order.notes }}', default: 'GoParrot' }),
    IsString({ always: true }),
    IsOptional({ always: true }),
    LengthWithLVS(5, 250, { always: true }),
    Expose({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.READ, VendorExposeGroup.PATCH, VendorExposeGroup.FIXTURE] }),
    __metadata("design:type", String)
], CreateSquareMetadataDto.prototype, "checkTitleTemplate", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, description: 'If true, is used shipment fulfillment type for delivery order', default: false }),
    IsBoolean({ always: true }),
    IsOptional({ always: true }),
    Expose({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.READ, VendorExposeGroup.PATCH, VendorExposeGroup.FIXTURE] }),
    __metadata("design:type", Boolean)
], CreateSquareMetadataDto.prototype, "isShipmentEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, description: 'If true, the tags will be printed' }),
    IsBoolean({ always: true }),
    IsUndefinable({ always: true }),
    Expose({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.READ, VendorExposeGroup.PATCH, VendorExposeGroup.FIXTURE] }),
    __metadata("design:type", Boolean)
], CreateSquareMetadataDto.prototype, "showUserTags", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Tag title' }),
    IsString({ always: true }),
    IsUndefinable({ always: true }),
    LengthWithLVS(1, 25, { always: true }),
    Expose({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.READ, VendorExposeGroup.PATCH, VendorExposeGroup.FIXTURE] }),
    __metadata("design:type", String)
], CreateSquareMetadataDto.prototype, "tagTitle", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Pos order auto complete duration', example: 'P1W3D' }),
    IsString({ always: true }),
    IsUndefinable({ always: true }),
    LengthWithLVS(1, 250, { always: true }),
    Expose({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.READ, VendorExposeGroup.PATCH, VendorExposeGroup.FIXTURE] }),
    __metadata("design:type", String)
], CreateSquareMetadataDto.prototype, "autoCompleteDuration", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, description: 'If true, update order in progress', default: false }),
    IsBoolean({ always: true }),
    IsOptional({ always: true }),
    Expose({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.READ, VendorExposeGroup.PATCH, VendorExposeGroup.FIXTURE] }),
    __metadata("design:type", Boolean)
], CreateSquareMetadataDto.prototype, "markOrderInProgress", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, description: 'If true, notes will be not sent in the pos', default: false }),
    IsBoolean({ always: true }),
    IsOptional({ always: true }),
    Expose({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.READ, VendorExposeGroup.PATCH, VendorExposeGroup.FIXTURE] }),
    __metadata("design:type", Boolean)
], CreateSquareMetadataDto.prototype, "isNoteSentDisabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, description: 'If true, will try to use defined line item tax', default: false }),
    IsBoolean({ always: true }),
    IsOptional({ always: true }),
    Expose({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.READ, VendorExposeGroup.PATCH, VendorExposeGroup.FIXTURE] }),
    __metadata("design:type", Boolean)
], CreateSquareMetadataDto.prototype, "tryToUseDefinedLineItemTax", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, description: 'If true and dining option is delivery, send readyPrepAt as pickup_at to POS', default: false }),
    IsBoolean({ always: true }),
    IsOptional({ always: true }),
    Expose({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.READ, VendorExposeGroup.PATCH, VendorExposeGroup.FIXTURE] }),
    __metadata("design:type", Boolean)
], CreateSquareMetadataDto.prototype, "sendReadyPrepAtAsPosPickupAt", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, description: 'If true, is used delivery type fulfillment for delivery dining option', default: true }),
    IsBoolean({ always: true }),
    IsOptional({ always: true }),
    Expose({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.READ, VendorExposeGroup.PATCH, VendorExposeGroup.FIXTURE] }),
    __metadata("design:type", Boolean)
], CreateSquareMetadataDto.prototype, "isDeliveryEnabled", void 0);
__decorate([
    ApiPropertyOptional({
        type: () => Boolean,
        description: 'If true, is used delivery type fulfillment for dine in dining option. This is an SQ workaround for order to table',
    }),
    IsBoolean({ always: true }),
    IsOptional({ always: true }),
    Expose({ groups: [VendorExposeGroup.CREATE, VendorExposeGroup.READ, VendorExposeGroup.PATCH, VendorExposeGroup.FIXTURE] }),
    __metadata("design:type", Boolean)
], CreateSquareMetadataDto.prototype, "isDineInEnabled", void 0);
//# sourceMappingURL=CreateSquareMetadataDto.js.map